// Collection banner slider
class CollectionBannerSlider extends HTMLElement {
  connectedCallback() {
    this.initSlider();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  get sliderEl() {
    return this.querySelector("[data-swiper]");
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderEl, {
      slidesPerView: "auto",
      spaceBetween: 0,
    });
  }

  destroySlider() {
    if(this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

if(!customElements.get("fs-collection-banner")) {
  customElements.define("fs-collection-banner", CollectionBannerSlider);
}

// image banner text slider
class TextSlider extends HTMLElement{
  constructor(){
    super();
  }

  connectedCallback(){
    new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    })
  }
}

if(!customElements.get("fs-text-slider")){
  customElements.define("fs-text-slider", TextSlider);
}

// testimonial slider
class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 51,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: ".pf-testimonial-section .pf-next",
        prevEl: ".pf-testimonial-section .pf-prev",
      },
    });
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  destroySlider() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

if (!customElements.get("fs-testimonial-slider")) {
  customElements.define("fs-testimonial-slider", TestimonialSlider);
}


// Text with icon slider
class TextWithIconSlider extends HTMLElement {
  connectedCallback() {
    this.initSlider();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  get sliderEl() {
    return this.querySelector("[data-swiper]");
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderEl, {
      slidesPerView: "auto",
      spaceBetween: 11,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      breakpoints: {
        480: {
          slidesPerView: 1.5,
        },
        660: {
          slidesPerView: 2,
        },
        991: {
          slidesPerView: 3,
        },
        1400: {
          slidesPerView: 4
        }
      }
    });
  }

  destroySlider() {
    if(this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

if(!customElements.get("fs-text-icon-slider")) {
  customElements.define("fs-text-icon-slider", TextWithIconSlider);
}


// Multicolumn slider
class MulticolumnSlider extends HTMLElement {
  connectedCallback() {
    this.initSlider();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  get sliderEl() {
    return this.querySelector("[data-swiper]");
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderEl, {
      slidesPerView: 1.8,
      spaceBetween: 6,
      breakpoints: {
        390: {
          slidesPerView: 2.1,
        },
        768: {
          slidesPerView: 2.5,
        },
        992: {
          slidesPerView: 3.2,
        },
        1200: {
          slidesPerView: 5.1,
          spaceBetween: 10,
        }
      }
    });
  }

  destroySlider() {
    if(this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

if(!customElements.get("fs-multicolumn-slider")) {
  customElements.define("fs-multicolumn-slider", MulticolumnSlider);
}


// sound trigger
class SoundTrigger extends HTMLElement {
  constructor(){
    super();
  }

  connectedCallback(){
    this.addEventListener("click",()=>{
      const video = this.closest("deferred-media").querySelector("video");

      if(this.getAttribute("sound") === "true"){
        this.setAttribute("sound", false);
        video.muted = true;
      } else {
        this.setAttribute("sound", true);
        video.muted = false;
      }
    })
  }
}

if(!customElements.get("sound-btn")){
  customElements.define("sound-btn", SoundTrigger);
}


// Countdown banner
class FsCountdown extends HTMLElement {
  #interval = null;

  connectedCallback() {
    this.startTimer();
  }

  disconnectedCallback() {
    this.reset();
  }

  // --- Parse input as New York time and convert to local time ---
  get endDate() {
    const [day, month, year] = (this.dataset.endDate || "").split("/");
    // New York midnight on that date
    const nyDate = new Date(`${year}-${month}-${day}T00:00:00-04:00`);
    return nyDate;
  }
  
  get daysEl() {
    return this.querySelector("[data-days]");
  }

  get hoursEl() {
    return this.querySelector("[data-hours]");
  }

  get minutesEl() {
    return this.querySelector("[data-minutes]");
  }

  get secondsEl() {
    return this.querySelector("[data-seconds]");
  }

  startTimer() {
    if(!this.isValidDate(this.endDate)) return;

    this.#interval = setInterval(() => {
      const remainingTime = this.getTimeRemaining(this.endDate);
      this.renderCountdown(remainingTime);
    }, 1000);
  }

  renderCountdown({ days, hours, minutes, seconds }) {
    this.daysEl.textContent = days;
    this.hoursEl.textContent = hours;
    this.minutesEl.textContent = minutes;
    this.secondsEl.textContent = seconds;
  }

  reset() {
    if (this.#interval) {
      clearInterval(this.#interval);
      this.#interval = null;
    }
  }

  getTimeRemaining(endDate) {
    const second = 1000,
          minute = second * 60,
          hour = minute * 60,
          day = hour * 24;
  
    const end = new Date(endDate).getTime();
    const now = new Date().getTime();
    const distance = end - now;
  
    const format = (num) => String(num).padStart(2, "0");
  
    if (distance <= 0) {
      return { days: "00", hours: "00", minutes: "00", seconds: "00" };
    }
  
    return {
      days: format(Math.floor(distance / day)),
      hours: format(Math.floor((distance % day) / hour)),
      minutes: format(Math.floor((distance % hour) / minute)),
      seconds: format(Math.floor((distance % minute) / second))
    };
  };

  isValidDate(date) {
    return !isNaN(new Date(date).getTime());
  }
}

if(!customElements.get("fs-countdown")) {
  customElements.define("fs-countdown", FsCountdown);
}


// Gallery Slider
class GallerySlider extends HTMLElement {
  connectedCallback() {
    this.initSlider();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  get sliderEl() {
    return this.querySelector("[data-swiper]");
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderEl, {
      slidesPerView: 3.3,
      spaceBetween: 8,
      // loop: true,
      // autoplay: {
      //   delay: 0,
      //   pauseOnMouseEnter: false,
      //   disableOnInteraction: false
      // },
      speed: 500,
      navigation: {
        prevEl: this.querySelector("[data-prev-btn]"),
        nextEl: this.querySelector("[data-next-btn]"),
      },
      breakpoints: {
        320: {
          slidesPerView: 4.5
        },
        390: {
          slidesPerView: 5.3,
          spaceBetween: 8
        },
        576: {
          slidesPerView: 6.5,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 7.5,
          spaceBetween: 12
        },
        1140: {
          slidesPerView: 8.5,
          spaceBetween: 18
        },
        1400: {
          slidesPerView: 9.5,
          spaceBetween: 24
        }
      }
    });
  }

  destroySlider() {
    if(this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

if(!customElements.get("fs-gallery-slider")) {
  customElements.define("fs-gallery-slider", GallerySlider);
}


// product accordion

class FsAccordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const accordions = this.querySelectorAll('[accordion-item]');

        accordions.forEach(accordion => {
            const header = accordion.querySelector('[accordion-header]');
            const content = accordion.querySelector('[accordion-content]');
            const icon = header.querySelector('.chevron-down');

            header.addEventListener('click', () => {
                const isActive = content.classList.contains('active');
                const height = content.querySelector(".accordion-text").scrollHeight;
                content.style.height = isActive ? '0px' : `${height}px`;

                // Close all other accordions
                this.querySelectorAll('[accordion-content]').forEach(item => {
                    item.classList.remove('active');
                });
                this.querySelectorAll('.chevron-down').forEach(chevron => {
                    chevron.classList.remove('active');
                });

                // Open current if it wasn’t active
                if (!isActive) {
                    content.classList.add('active');
                    if (icon) icon.classList.add('active');
                }
            });
        });
    }
}

if (!customElements.get('fs-accordion')) {
    customElements.define('fs-accordion', FsAccordion);
}


// fs product slider
class ProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const mainSlider = this.querySelector("[main-slider]");
    const thumbSlider = this.querySelector("[thumb-slider]");

    if (mainSlider && thumbSlider) {
      const thumbSwiper = new Swiper(thumbSlider, {
        slidesPerView: 4,
        spaceBetween: 8,
        pagination: {
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      new Swiper(mainSlider, {
        slidesPerView: 1.1,
        spaceBetween: 18,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints:{
          992: {
            slidesPerView: 1,
            spaceBetween: 30,
          }
        },
        thumbs: {
          swiper: thumbSwiper,
        },
      });
    }
  }
}

if (!customElements.get("fs-product-gallery")) {
  customElements.define("fs-product-gallery", ProductSlider);
}


// fs complete look


class CompleteLook extends HTMLElement{
  constructor(){
    super();
  }

  connectedCallback(){
    const productItems = this.querySelectorAll("[data-product-item]");

    productItems.forEach((item, index)=>{
      const variantId = item.getAttribute("variant-id");
      const input = item.querySelector("input");

      item.addEventListener("click", ()=>{
        input.click();
      });

      input.addEventListener("change", ()=>{
        this.handleChange(variantId, input.checked, index);
      });
    })
  }

  handleChange(variantId, state, index) {
    const form = document.querySelector(`form[action="/cart/add"]`);
    if (!form) return;

    // look for an existing block for this variant
    const existingBlock = form.querySelector(`[data-variant-block="${variantId}"]`);

    if (state) {
      if (!existingBlock) {
        const wrapper = document.createElement("div");
        wrapper.setAttribute("data-variant-block", variantId);

        const idInput = document.createElement("input");
        idInput.type = "hidden";
        idInput.name = `items[${index}][id]`;
        idInput.value = variantId;

        const qtyInput = document.createElement("input");
        qtyInput.type = "hidden";
        qtyInput.name = `items[${index}][quantity]`;
        qtyInput.value = "1";

        wrapper.appendChild(idInput);
        wrapper.appendChild(qtyInput);

        form.appendChild(wrapper);
      }
    } else {
      if (existingBlock) {
        existingBlock.remove();
      }
    }
  }
}

if(!customElements.get("fs-complete-look")){
  customElements.define("fs-complete-look", CompleteLook);
}


// Newsletter success
class NewsletterSuccess extends HTMLElement {
 connectedCallback() {
    this.codeEl.addEventListener("click", (e) => {
      navigator.clipboard.writeText(this.dataset.code);
    })
  }

  disconnectedCallback() {
    
  }

  get codeEl() {
    return this.querySelector("[data-code]");
  }
}

if(!customElements.get("fs-newsletter-success")) {
  customElements.define("fs-newsletter-success", NewsletterSuccess);
}


// Email Popup
class FsEmailPopup extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    if(!localStorage.getItem("fsSubscribed") && (!this.showOnlyOnce || !localStorage.getItem("fsShowedPopup"))) {
      setTimeout(() => {
        this.open()
      }, this.popupOpenDelay);
    };

    this.closeButtons.forEach(btn => {
      btn.addEventListener("click", this.close.bind(this), { signal });
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get showOnlyOnce() {
    return this.dataset.showOnce == "true";
  }

  get popupOpenDelay() {
    return 1000 * this.dataset.delay;
  }

  get wrapper() {
    return this.querySelector(".fs-epop-wrapper");
  }

  get closeButtons() {
    return [...this.querySelectorAll("[data-close]")];
  }

  open() {
    this.setAttribute("data-open", true);

    if(this.showOnlyOnce) {
      localStorage.setItem("fsShowedPopup", true);
    }
  }

  close() {
    if(!this.querySelector(".fs-epop-input")) {
      localStorage.setItem("fsSubscribed", true);
    }

    if (window.location.href.includes("?customer_posted=true#contact_form")) {
      window.history.replaceState(
        {},
        "",
        window.location.href.replace("?customer_posted=true#contact_form", "")
      );
    }
    
    this.setAttribute("data-open", false);
  }
}

if(!customElements.get("fs-email-popup")) {
  customElements.define("fs-email-popup", FsEmailPopup);
}



document.addEventListener("DOMContentLoaded", function () {
  const firstMegaMenuColNew = document.querySelector(".megamenu__cols_new .megamenu__col_new:first-child");
  if (firstMegaMenuColNew) {
      firstMegaMenuColNew.classList.add("active");
  }

  const firstMegaMenuColTitle = document.querySelector(".megamenu__col_left .megamenu__col-title:first-child");
  if (firstMegaMenuColTitle) {
      firstMegaMenuColTitle.classList.add("active");
  }
});




document.querySelectorAll('.megamenu__title_parent a').forEach(link => {
  link.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default link behavior if needed
      
      // Handle parent active class
      let parent = this.closest(".yv-dropdown-detail");
      // parent.setAttribute("open", "true");
      // parent = this.closest(".yv-dropdown-detail");
      // console.log(parent);
      
      document.querySelectorAll('.megamenu__title_parent').forEach((elm) => elm.classList.remove("active"));
      link.closest(".megamenu__title_parent").classList.add("active");

      // Remove active class from parent siblings
      const siblings = parent.parentElement.children;
      for (let sibling of siblings) {
          if (sibling !== parent) {
              sibling.classList.remove('active');
          }
      }
      
      // Handle megamenu__col_new based on data-id
      const dataId = this.getAttribute('data-id');
      if (dataId) {
          document.querySelectorAll('.megamenu__col_new').forEach(col => {
              if (col.id === dataId) {
                  col.classList.add('active');
              } else {
                  col.classList.remove('active');
              }
          });
      }
  });
});


// or tabs that can only have one open at a time
(function() {
  var selectors = {
    trigger: '.collapsible-trigger',
    module: '.collapsible-content',
    moduleInner: '.collapsible-content__inner',
    tabs: '.collapsible-trigger--tab'
  };

  var classes = {
    hide: 'hide',
    open: 'is-open',
    autoHeight: 'collapsible--auto-height',
    tabs: 'collapsible-trigger--tab'
  };

  var namespace = '.collapsible';

  var isTransitioning = false;

  function init(scope) {
    var el = scope ? scope : document;
    el.querySelectorAll(selectors.trigger).forEach(trigger => {
      var state = trigger.classList.contains(classes.open);
      trigger.setAttribute('aria-expanded', state);

      trigger.off('click' + namespace);
      trigger.on('click' + namespace, toggle);
    });
  }

  function toggle(evt) {
    if (isTransitioning) {
      return;
    }

    isTransitioning = true;

    var el = evt.currentTarget;
    var isOpen = el.classList.contains(classes.open);
    var isTab = el.classList.contains(classes.tabs);
    var moduleId = el.getAttribute('aria-controls');
    var container = document.getElementById(moduleId);

    if (!moduleId) {
      moduleId = el.dataset.controls;
    }

    // No ID, bail
    if (!moduleId) {
      return;
    }

    // If container=null, there isn't a matching ID.
    // Check if data-id is set instead. Could be multiple.
    // Select based on being in the same parent div.
    if (!container) {
      var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
      if (multipleMatches.length > 0) {
        container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
      }
    }

    if (!container) {
      isTransitioning = false;
      return;
    }

    var height = container.querySelector(selectors.moduleInner).offsetHeight;
    var isAutoHeight = container.classList.contains(classes.autoHeight);
    var parentCollapsibleEl = container.parentNode.closest(selectors.module);
    var childHeight = height;

    if (isTab) {
      if(isOpen) {
        isTransitioning = false;
        return;
      }

      var newModule;
      document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
        el.classList.remove(classes.open);
        newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
        setTransitionHeight(newModule, 0, true);
      });
    }

    // If isAutoHeight, set the height to 0 just after setting the actual height
    // so the closing animation works nicely
    if (isOpen && isAutoHeight) {
      setTimeout(function() {
        height = 0;
        setTransitionHeight(container, height, isOpen, isAutoHeight);
      }, 0);
    }

    if (isOpen && !isAutoHeight) {
      height = 0;
    }

    el.setAttribute('aria-expanded', !isOpen);
    if (isOpen) {
      el.classList.remove(classes.open);
    } else {
      el.classList.add(classes.open);
    }

    setTransitionHeight(container, height, isOpen, isAutoHeight);

    // If we are in a nested collapsible element like the mobile nav,
    // also set the parent element's height
    if (parentCollapsibleEl) {
      var parentHeight = parentCollapsibleEl.style.height;

      if (isOpen && parentHeight === 'auto') {
        childHeight = 0; // Set childHeight to 0 if parent is initially opened
      }

      var totalHeight = isOpen
                      ? parentCollapsibleEl.offsetHeight - childHeight
                      : height + parentCollapsibleEl.offsetHeight;

      setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
    }
  }

  function setTransitionHeight(container, height, isOpen, isAutoHeight) {
    container.classList.remove(classes.hide);
    theme.utils.prepareTransition(container, function() {

      container.style.height = height+'px';
      if (isOpen) {
        container.classList.remove(classes.open);
      } else {
        container.classList.add(classes.open);
      }
    });

    if (!isOpen && isAutoHeight) {
      var o = container;
      window.setTimeout(function() {
        o.css('height','auto');
        isTransitioning = false;
      }, 500);
    } else {
      isTransitioning = false;
    }
  }

  return {
    init: init
  };
})();


class FsHeroSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        new Swiper(this, {
            slidesPerView: 1,
            loop: true,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
            },
        });
    }
}

if(!customElements.get('fs-hero-slider')){
    customElements.define('fs-hero-slider', FsHeroSlider);
}



document.addEventListener("DOMContentLoaded", () => {
  const title = document.querySelector(".fs-imgbanner-title");

  if (!title) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        title.classList.add("animate");
        observer.unobserve(entry.target); // run once
      }
    });
  }, { threshold: 0.4 });

  observer.observe(title);
});